import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import ImageSwiper from "components/ImageSwiper";
import Login from "./Login";
// import SignUp from "./SignUp";
import ForgetPassword from "./ForgetPassword";
import VerifyEmail from "./VerifyEmail";
import AddKey from "./AddKey";
import NewPassword from "./NewPassword";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import useMediaQuery from "hooks/useMediaQuery";
import VerifyPhone from "./VerifyPhone";

export default function UserAuth() {
  const { dir, tenant: tenantDetail } = useAppSelector(getSettings);
  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);

  return (
    <>
      <div 
        className="h-dvh w-dvw flex items-center justify-center relative overflow-hidden" 
        style={{
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
        }}
        dir={dir}
      >
        {/* Minimal Grid Background */}
        <div 
          className="absolute inset-0 opacity-100"
          style={{
            backgroundImage: `
              linear-gradient(rgba(255, 255, 255, 0.17) 1px, transparent 1.5px),
              linear-gradient(90deg, rgba(255, 255, 255, 0.41) 1px, transparent 1.5px)
            `,
            backgroundSize: '20px 20px'
          }}
        />
        
        {/* Main container with full height flex */}
        <div className="w-full h-full flex flex-col items-center justify-between p-6 relative z-10">
          {/* Header section - Logo/Brand at top */}
          <div className="flex items-center justify-center w-full">
            {tenantDetail?.profile_image ? (
              <a 
                href={tenantDetail?.website} 
                target="_blank" 
                rel="noreferrer"
                className="transition-transform hover:scale-105"
              >
                <img
                  src={tenantDetail?.profile_image}
                  alt={tenantDetail?.institution_title}
                  className="w-32 md:w-48 object-contain h-16 md:h-20"
                />
              </a>
            ) : (
              <div className="w-32 md:w-48 h-16 md:h-20 bg-gray-100 rounded-lg flex items-center justify-center">
                <span className="text-gray-400 text-sm">Logo</span>
              </div>
            )}
          </div>

          {/* Glassmorphic Card Container - Centered */}
          <div className="flex-1 flex items-center justify-center w-full max-w-md">
            <div 
              className="w-full bg-white/25 backdrop-blur-xl rounded-2xl border border-white/30 shadow-2xl p-8"
              style={{
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.4)'
              }}
            >
              {/* Main content area - Auth forms */}
              <div className="w-full">
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forget-password" element={<ForgetPassword />} />
                  <Route
                    path="/forget-password/verify"
                    element={<VerifyEmail forgetPassword />}
                  />
                  <Route
                    path="/verify-phone"
                    element={<VerifyPhone forgetPassword />}
                  />
                  <Route path="/verify-email" element={<VerifyEmail />} />
                  <Route path="/add-key" element={<AddKey />} />
                  <Route path="/new-password" element={<NewPassword />} />
                  <Route path="/*" element={<Navigate to="/register" />} />
                </Routes>
              </div>
            </div>
          </div>

          {/* Footer section - Powered by at bottom */}
          <div className="flex items-center justify-center gap-2 text-sm text-gray-600" dir="ltr">
            <span>Powered by</span>
            <img
              src={require("../../assets/logo/logo.png")}
              alt="Nexme"
              className="object-contain h-5 mb-1.5"
            />
          </div>
        </div>
      </div>
    </>
  );
}
